import { Expose, Transform } from 'class-transformer'
import { MarginTypeEnum } from '@interfaces/MarginTypeEnum'
import { TradeSideEnum } from '@interfaces/TradeSideEnum'

export class BotStrategiesMainForm {
  @Expose()
  id?: number

  @Expose()
  name: string

  @Expose()
  @Transform(
    ({ obj }) =>
      obj.isInfinityCycle
        ? 'infinity'
        : obj.cycleQuantity > 1
        ? 'cycle'
        : 'single',
    {
      toClassOnly: true,
    }
  )
  @Expose()
  @Transform(({ value }) => value === 'cycle' || value === 'infinity', {
    toPlainOnly: true,
  })
  isCycle: 'cycle' | 'single' | 'infinity'

  @Expose()
  @Transform(
    ({ value }) => {
      return value === true || value === 'split' ? 'split' : 'all'
    },
    {
      toClassOnly: true,
    }
  )
  @Transform(({ value }) => value === 'split', { toPlainOnly: true })
  isSplitTp: 'all' | 'split'

  @Expose()
  @Transform(({ obj }) => obj.isCycle === 'infinity', { toPlainOnly: true })
  isInfinityCycle: boolean

  @Expose()
  marginType: MarginTypeEnum

  // DESC: P'Ohm suggest us to let every bot could be hedge mode.
  @Expose()
  @Transform(
    ({ value }) => (value === TradeSideEnum.HEDGE_MODE ? null : value),
    {
      toPlainOnly: true,
    }
  )
  @Transform(({ value }) => value || TradeSideEnum.HEDGE_MODE, {
    toClassOnly: true,
  })
  side: TradeSideEnum

  @Expose()
  isCovering: boolean

  @Expose()
  cycleQuantity: number

  @Expose()
  isStopLoss: boolean

  @Expose()
  // DESC: P'Ohm suggest us to let every bot could be hedge mode.
  @Transform(() => true, {
    toPlainOnly: true,
  })
  isHedgeMode: boolean

  @Expose()
  isFirstOrderDouble: boolean

  @Expose()
  firstOrderRawQuote: number

  @Expose()
  @Transform(
    ({ obj }) =>
      obj.isFirstOrderDouble
        ? obj.firstOrderRawQuote * 2
        : obj.firstOrderRawQuote,
    {
      toPlainOnly: true,
    }
  )
  firstOrderTradeQuote: number

  @Expose()
  leverage: number

  @Expose()
  coveringQuantity: number

  @Expose()
  @Transform(({ value }) => value * 100, {
    toClassOnly: true,
  })
  @Transform(({ value }) => value / 100, {
    toPlainOnly: true,
  })
  tpRetracement: number

  @Expose()
  @Transform(({ value }) => value * 100, {
    toClassOnly: true,
  })
  @Transform(({ value }) => value / 100, {
    toPlainOnly: true,
  })
  tpRatio: number

  @Expose()
  divisionAndControlProfit: number

  @Expose()
  @Transform(
    ({ obj, value }) =>
      obj.stopLossLimit ? null : obj.isStopLoss ? value / 100 : undefined,
    {
      toPlainOnly: true,
    }
  )
  stopLossRatio?: number

  @Expose()
  @Transform(
    ({ obj, value }) =>
      obj.stopLossRatio ? null : obj.isStopLoss ? value : undefined,
    {
      toPlainOnly: true,
    }
  )
  stopLossLimit?: number

  coverSpreads?: number[]

  coverSpreadTrends?: number[]

  coverMultiples?: number[]

  pullbackSpreads?: number[]

  tpRetracementSplit?: number[]

  tpRatioSplit?: number[]

  @Expose()
  limitPrice?: number
}
